import { html, css, LitElement, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { Map, View } from 'ol'
import OSM from 'ol/source/OSM';
import TileLayer from 'ol/layer/Tile'
import olStylesText from 'ol/ol.css';
import { Style, Icon, Text, Fill, Stroke } from 'ol/style'
import Point from 'ol/geom/Point'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import { Modify, defaults as defaultInteractions } from 'ol/interaction'
import Feature from 'ol/Feature'
import { fromLonLat, toLonLat } from 'ol/proj'
import Overlay from 'ol/Overlay';
import { getWidth } from 'ol/extent';
import FullScreen from 'ol/control/FullScreen'
import { defaults as defaultControls } from 'ol/control/defaults';

export class TrailMap extends LitElement {
    static styles = [
        unsafeCSS(olStylesText),
        css`
*, ::after, ::before {
    box-sizing: border-box;
}
.tooltip {
  position: absolute;
  background-color: white;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  pointer-events: none; /* Prevents the tooltip from flickering when the mouse enters it */
  display: none;
}
.ol-full-screen button {
  cursor: pointer;
}
:host { display: block; }
.map { 
    width: 100%; 
    height: 500px; 
    background: #eee; 
}
@media(min-width: 768px) {
    .map {
        height: 800px;
    }
}
.ol-popup, .map, .ol-viewport {
    transition: none !important;
}
/* The main container needs to allow absolute positioning for the arrow */
.ol-popup {
    position: absolute;
    background-color: white;
    padding: 15px;
    border-radius: 10px;
    border: 1px solid #fff;
    bottom: 12px;
    left: -50px;
    min-width: 232px;
    font-weight: 300;
    font-size: 13px;
    filter: drop-shadow(0 1px 4px rgba(0,0,0,0.2));
}


    /* The "Outer" triangle (the border) */
    .ol-popup::before {
        border-top: 10px solid white;
        border-right: 10px solid transparent;
        border-left: 10px solid transparent;
        content: "";
        height: 0;
        width: 0;
        position: absolute;
        bottom: -9px; /* Positions it just below the border */
        left: 40px; /* Aligns it under the popup */
    }

    /* The "Inner" triangle (the white fill) */
    .ol-popup::after {
        border-top: 10px solid white;
        border-right: 10px solid transparent;
        border-left: 10px solid transparent;
        content: "";
        height: 0;
        width: 0;
        position: absolute;
        bottom: -9px;
        left: 40px;
    }
    .ol-popup-closer { text-decoration: none; position: absolute; top: 2px; right: 8px; color: #333; }
@media (min-width: 992px) {
    .d-md-flex {
        display: flex;
    }
}
.listingid {
    padding-left: 16px;
    font-size: 16px;
}
.title {
    font-size: 18px;
    font-weight: bold;
    margin-top: 8px;
    margin-bottom: 8px;
}
a {
    color: #333;
    text-decoration: none;
}
a.add-to-favorites, a.remove-from-favourites {
    text-decoration: underline; 
}
@media (min-width: 768px) {
    .title {
        font-size: 24px;
        margin-top: 20px;
        margin-bottom: 20px;
    }
}
.multiple .title { 
    margin-top: 8px!important;
    margin-bottom: 8px!important;
}
.medium, .address {
    margin-bottom: 10px;
}
.infowindow {
    max-height: 400px;
    overflow-y: auto;
}
.infowindow .mapimg img {
    width: 250px;
    aspect-ratio: 4 / 3;
}
.infowindow .details img {
    width: 24px;
    margin-right: 4px;
}
.infowindow .name {
    font-weight: bold;
    font-size: 18px;
}
.infowindow .details {
    font-size: 16px;
    font-weight: normal;
}
.infowindow .maplink {
    font-size: 16px;
    margin-top: 20px;
    display: block;
}
.infowindow .maplink:hover {
    text-decoration: underline;
}
.infowindow .details > div {
    display: flex;
    align-items: center;    
}
.infowindow.multiple .info:not(:last-child) {
    margin-bottom: 30px;
}
.tooltip-content {
    font-size: 12px;
    position: relative;
}
.medium-key {
    padding-top: 30px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
}
.medium-key > * {
    display: flex;
    align-items: center;
}

.medium-key img {
    margin-right: 8px;
}
@media (min-width: 768px) {
    .medium-key {
        grid-template-columns: 1fr 1fr 1fr;
    }
}
        `
    ];


    map = null
    markerSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="63" height="75" viewBox="0 0 42 50"><g fill="none" fill-rule="evenodd"><g transform="translate(10 5)"><path fill="#007b80" d="M3.225 3.364C12.96-6.204 27.504 6.515 19.86 18.068L11 29.676 2.107 18.073C-1.079 13.525-.609 7.339 3.225 3.365z"/></g><path fill="#fff" d="M21.501 19.914c.34-.241.63-.486.884-.747a7 7 0 0 0 1.14-1.554.506.506 0 0 0-.204-.683.5.5 0 0 0-.678.205 6 6 0 0 1-.98 1.328c-.047.047-.1.087-.155.13l-.007.004V13.53a.501.501 0 1 0-1.002 0v3.027l-.008-.006a1.3 1.3 0 0 1-.16-.133 6 6 0 0 1-.97-1.329.501.501 0 1 0-.88.477 7 7 0 0 0 1.141 1.555c.251.258.54.502.877.742v3.12c-1.132-.201-2.995-1.417-3.432-3.945-.26-1.523.27-3.336 1.35-4.618.769-.912 1.686-1.415 2.583-1.415.899 0 1.816.503 2.58 1.415 1.083 1.282 1.613 3.095 1.35 4.618-.434 2.527-2.297 3.744-3.429 3.946zm2.85-8.141C23.387 10.63 22.198 10 21 10c-1.199 0-2.388.63-3.35 1.77-1.281 1.525-1.882 3.607-1.568 5.434.29 1.698 1.747 4.488 4.417 4.815v1.478a.502.502 0 0 0 .855.356.5.5 0 0 0 .147-.356V22.02c2.671-.327 4.125-3.116 4.417-4.813.314-1.828-.287-3.91-1.568-5.433z"/></g></svg>`;

    //markerSVGUrl = 'data:image/svg+xml;base64,' + btoa(this.markerSVG);


    // 2. Convert to a safe Data URI
    markerSVGUrl = 'data:image/svg+xml;utf8,' + encodeURIComponent(this.markerSVG);

    markerStyle = new Style({
        image: new Icon({
            anchor: [0.5, 1],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            src: this.markerSVGUrl,
            imgSize: [63, 75],
            scale: 1
        }),
    });
    marker = new Feature();
    markerLayer = new VectorLayer({
        source: new VectorSource(),
        renderOptions: {
            willReadFrequently: true
        }
    });

    infowindow = undefined

    constructor() {
        super();

    }

    fitBounds() {
        this.map.updateSize();
        const extent = this.markerLayer.getSource().getExtent();
        //console.log("Fitting bounds to extent:", extent)
        if (!extent || extent[0] === Infinity) return;
        this.map.getView().fit(extent, {
            maxZoom: 16,
            padding: [100, 50, 50, 50],
        });

    }

    show() {
        this.map.updateSize();
        this.fitBounds()
    }


    setTrails(trails) {
        this.infowindow.setPosition(undefined)
        this.clearMarkers()
        this.setupMarkers()
        this.requestUpdate();
    }

    clearMarkers() {
        const source = this.markerLayer.getSource();
        source.clear();
    }

    getMarkerCords(coords) {
        return fromLonLat([coords.longitude, coords.latitude])
    }

    setupInfoWindow() {
        const container = this.shadowRoot.getElementById('popup')
        this.infocontent = this.shadowRoot.getElementById('popup-content')
        const closer = this.shadowRoot.getElementById('popup-closer')
        //console.log("Setting up info window with container:", container, "content:", this.infocontent, "closer:", closer)
        this.infowindow = new Overlay({
            element: container,
            autoPanMargin: 150,
            //positioning: 'top-center',
            // Fine-tune the vertical gap (up 15px to account for the arrow length)
            offset: [0, -65],
            autoPan: true
        });
        this.map.addOverlay(this.infowindow)
        if (closer) {

            closer.onclick = () => {
                this.infowindow.setPosition(undefined);
                return false;
            }
        }
    }


    getInfoWindowContent(features) {
        let result = "";
        features.forEach(feature => {
            const trail = feature.get("trail")
            //console.log(trail)
            let image = ""
            let img = trail.querySelector("img")
            if (img) {
                image = "<a target=\"_blank\" href=\"" + trail.href + "\" class=\"mapimg\">" + img.outerHTML + "</a>"
            }
            let details = ""
            if (trail.querySelector(".location")) {
                details += trail.querySelector(".location").outerHTML
            }
            if (trail.querySelector(".uses")) {
                details += trail.querySelector(".uses").outerHTML
            }
            if (trail.querySelector(".distance")) {
                details += trail.querySelector(".distance").outerHTML
            }

            if (details != "") {
                details = "<a target=\"_blank\" href=\"" + trail.href + "\"  class=\"details\">" + details + "</a>"
            }

            result += "<div class=\"info\">" + "<a class=\"name\" target=\"_blank\" href=\"" + trail.href + "\">" + trail.querySelector(".name").innerText + "</a>" +
                image + details + "<a class=\"maplink\" target=\"_blank\" href=\"https://maps.google.com/?q=" + trail.dataset.lat + "," + trail.dataset.lng + "&ll=" + trail.dataset.lat + "," + trail.dataset.lng + "&z=16\">View on Google Maps</a>" +                "</div>"
        })
        const multiple = features.length > 1 ? ` multiple` : ""
        result = `<div class="infowindow${multiple}">${result}</div>`
        return result;
    }

    handleMapClick(source, feature) {
        if (feature) {
            const coordinates = feature.getGeometry().getCoordinates();
            const matchingFeatures = source.getFeaturesAtCoordinate(coordinates);

            this.infocontent.innerHTML = this.getInfoWindowContent(matchingFeatures)
            this.infocontent.querySelectorAll(".title a").forEach(link => {
                link.addEventListener("click", (event) => {
                    event.preventDefault();
                    if (document.fullscreenElement) {
                        document.exitFullscreen()
                            .then(() => console.log("Exited full screen"))
                            .catch((err) => console.error(err));
                    }
                    history.pushState(null, null, link.href)
                });
            });
            this.infowindow.setPosition(undefined);
            this.infowindow.setPosition(coordinates);
            this.infowindow.panIntoView();
        } else {
            this.closePopup()
        }
    }

    setupMarkers() {
        const mapContainer = this.shadowRoot.querySelector('.map');
        const source = this.markerLayer.getSource()
        if (this.trails) {
            this.trails.forEach(trail => {
                if (trail.classList.contains("visible")) {
                    const lat = trail.dataset.lat
                    const lng = trail.dataset.lng
                    if (!isNaN(lat) && !isNaN(lng)) {
                        //console.log("Adding marker for trail:", trail, "with coords:", { lat, lng });
                        const markerCoords = fromLonLat([lng, lat]);
                        const marker = new Feature({
                            geometry: new Point(markerCoords),
                            trail: trail,
                        })
                        marker.setStyle(this.markerStyle)
                        source.addFeature(marker)
                    }
                }
            })
        }
        this.fitBounds()
        //this.requestUpdate();
    }

    closePopup() {
        this.infowindow.setPosition(undefined);
    }

    async firstUpdated() {
        const mapContainer = this.shadowRoot.querySelector('.map');
        this.map = new Map({
            target: mapContainer,
            interactions: defaultInteractions({
                mouseWheelZoom: false
            }),
            controls: defaultControls().extend([
                new FullScreen()
            ]),
            layers: [
                new TileLayer({
                    source: new OSM(),
                }),
            ],
            view: new View({
                center: fromLonLat([175.0032646, -40.91553427]),
                zoom: 12,
            }),
            rendererOptions: {
                willReadFrequently: true
            }
        });
        this.setupInfoWindow()
        this.map.addLayer(this.markerLayer)

        this.setupMarkers();
        this._handleEsc = (event) => {
            if (event.key === 'Escape') {
                this.closePopup();
            }
        };
        this.map.on('singleclick', (evt) => {
            const feature = this.map.forEachFeatureAtPixel(evt.pixel, (f) => f);
            const source = this.markerLayer.getSource()
            this.handleMapClick(source, feature);
        })

        let pmTimer = null;

        this.map.on('pointermove', (evt) => {
            if (pmTimer) return;

            pmTimer = setTimeout(() => {
                const tooltipElement = this.shadowRoot.getElementById('tooltip');
                const feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
                    return feature;
                });
                const trail = feature ? feature.get("trail") : null;
                if (trail) {
                    // Show tooltip and set text
                    tooltipElement.innerHTML = `<div class="tooltip-content">${trail.dataset.summary}</div>`;
                    tooltipElement.style.display = 'block';
                    // Position the tooltip near the mouse
                    tooltipElement.style.left = (evt.pixel[0] + 10) + 'px';
                    tooltipElement.style.top = (evt.pixel[1] + 10) + 'px';
                } else {
                    // Hide tooltip if not hovering
                    tooltipElement.style.display = 'none';
                }

                const hit = this.map.hasFeatureAtPixel(evt.pixel, {
                    layerFilter: (layer) => {
                        // Return true ONLY for your interactive vector layer
                        // All other layers bypass the heavy hit-detection engine completely
                        return layer === this.markerLayer;
                    }
                });

                const mapTarget = this.map.getTargetElement();
                if (mapTarget) {
                    mapTarget.style.cursor = hit ? 'pointer' : '';
                }

                pmTimer = null;
            }, 100); // 100ms reduces the readback load to a comfortable 10fps
        });

        document.addEventListener('keydown', this._handleEsc);
    }

    render() {
        return html`<div style="position:relative">
                <div class="map"></div>
                <div id="tooltip" class="tooltip"></div>
                <div id="popup" class="ol-popup">
                  <a href="#" id="popup-closer" class="ol-popup-closer">✖</a>
                  <div id="popup-content"></div>
                </div>`;
    }
}
customElements.define('trail-map', TrailMap);